export const environment = {
  backendUrl: 'https://diagnostics-dev.amperfied-datahub.com'
};
